<div [class.c-attachment-box--error]="hasError" class="c-attachment-box">
	<ng-container *ngIf="attachment; else upload">
		<div class="center">
			{{ attachment.filename }}

			<button (click)="doRemove()" class="remove-btn">
				<span class="icon-close"></span>
			</button>
		</div>
	</ng-container>

	<ng-template #upload>
		<button (click)="selectFile()" class="c-btn-link upload-button" type="button">
			<img alt="Upload" src="/assets/icons/icon-sources/upload.svg"/>
			Bijlage toevoegen
		</button>

		<input #uploadButton (change)="handleFileInput($event.target.files)" [id]="'upload-button'" type="file"/>
	</ng-template>
</div>

<p *ngIf="hasError" class="u-text--sm u-text--error">Bijlage is verplicht.</p>
<p *ngIf="errorMessage" class="u-text--sm u-text--error">{{ errorMessage }}</p>
